// extracted by mini-css-extract-plugin
export default {"wrapper":"ContentHeader_wrapper__mmIu9","title":"ContentHeader_title__WmHwF"};